export const EMAIL_COLLECTION_VIEWED_KEY = 'health_email_collection_viewed'
export const EMAIL_COLLECTION_VIEWED_EXPIRATION_SECONDS = 60 * 60 * 24
export const EMAIL_COLLECTED_KEY = 'health_email_collected'
export const SUBMIT_DELAY = 1000
export const SCROLL_UP_THRESHOLD_PIXELS = 20
export const SCROLL_DOWN_DELAY = 1000
export const SCROLL_DOWN_THRESHOLD_PIXELS = 300
